import React from 'react';

export default function Loader({ white }) {
    return (
        <div className='spinner-box'>
            <div className={`three-quarter-spinner ${white && 'white'}`}></div>
        </div>
    );
}
